import { SectionOfDashboard } from "./SectionOfDashboard";

export class DashboardTemplateResponse {
  dateCreated!: string;
  name!: string;
  sections!: SectionOfDashboard[];
}
